enum JOURNEY {
  "SOLAR" = "solar",
  "SOLAR-BATTERY" = "solar and battery",
  "BATTERY" = "battery",
}

const isSolarBatteryJourney = (systemType: string) =>
  systemType === JOURNEY["SOLAR-BATTERY"];

const isBatteryJourney = (systemType: string) => systemType === JOURNEY.BATTERY;

const isSolarJourney = (systemType: string) => systemType === JOURNEY.SOLAR;

export { JOURNEY, isSolarBatteryJourney, isBatteryJourney, isSolarJourney };
